import React from "react";
import { Row, Col } from "react-bootstrap";
// import UnderstandingSectionIcon from "../../CommonTocComponent/UnderstandSection/UnderstandingSectionIcon";
import { EMutualFundFlow } from "../MutualFund";
import moment from "moment";
var Mandate = function (props) {
    return (React.createElement("div", { className: "createdmandate-ios" },
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: props.parentClassName },
                React.createElement("div", { className: "bankaccountsection" },
                    React.createElement("div", { className: "mandateleftsection" },
                        React.createElement("div", { className: "Roboto_10_400 txt-oslo_grey pb-10" }, props.accountNo),
                        React.createElement("div", { className: "DMSansMedium_12_500 txt_blackOne1" }, props.accountName),
                        React.createElement("div", { className: "" },
                            React.createElement("span", { className: "DMsanR_10_400 txt_secondary-gray" }, "status"),
                            React.createElement("span", { className: "DMSansNormal_12_400 ps-1", "data-attr": props.status.toLowerCase() }, props.status))),
                    React.createElement("div", { className: "mandaterightsection" },
                        React.createElement("div", { className: "Roboto_10_400 txt-oslo_grey" }),
                        React.createElement("div", null,
                            React.createElement("span", { className: "DMsanR_10_400 txt_secondary-gray" }, "Amt "),
                            React.createElement("span", { className: "RobotoM_12_500 pe-s" }, props.mandateAmt)),
                        React.createElement("div", null,
                            React.createElement("span", { className: "DMsanR_10_400 txt_secondary-gray" }, "Created on"),
                            React.createElement("span", { className: "DMSanN_12_400 ps-1" }, moment(props.createdDate).format("DD-MMM-YY")))),
                    props.showValidate && (React.createElement("div", null,
                        React.createElement("a", { onClick: function () {
                                props.handlevalidate(EMutualFundFlow.VALIDATEMANDATE);
                            } }, "Validate Mandate"))))))));
};
export default Mandate;
